// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarPeriodicidadeEstatisticaNumerador,
  getPeriodicidadeEstatisticaNumeradorSelecionada,
  getPeriodicidadeEstatistica,
} from "../../../../state";

export default function SelecaoPeriodicidadeEstatisticaNumerador() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"Periodicidade.Descricao"}
        itensSelector={getPeriodicidadeEstatistica}
        selectorItemSelecionado={
          getPeriodicidadeEstatisticaNumeradorSelecionada
        }
        onItemChange={selecionarPeriodicidadeEstatisticaNumerador}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
        radioName="periodicidadeEstatisticaNumerador"
      />
    </div>
  );
}
